import { createContext, useContext, type PropsWithChildren } from 'react';
import { useSearchParams } from 'react-router-dom';

import { dboUrlSearchKeys } from '../constants';

const RoxyContext = createContext<boolean>(false);

export const useRoxy = () => useContext(RoxyContext);

export const RoxyProvider = ({ children }: PropsWithChildren<object>) => {
  const [searchParams] = useSearchParams();
  const roxy = searchParams.get(dboUrlSearchKeys.roxy) === 'true';

  return <RoxyContext.Provider value={roxy}>{children}</RoxyContext.Provider>;
};
